import { azurePullRequestDashboardRouteRef, azurePipelinesEntityContentRouteRef, azureGitTagsEntityContentRouteRef, azurePullRequestsEntityContentRouteRef } from './routes.esm.js';
import { createPlugin, createApiFactory, discoveryApiRef, fetchApiRef, createRoutableExtension, createComponentExtension } from '@backstage/core-plugin-api';
import { AzureDevOpsClient } from './api/AzureDevOpsClient.esm.js';
import { azureDevOpsApiRef } from './api/AzureDevOpsApi.esm.js';
import { AZURE_DEVOPS_REPO_ANNOTATION, AZURE_DEVOPS_PROJECT_ANNOTATION, AZURE_DEVOPS_BUILD_DEFINITION_ANNOTATION } from '@backstage-community/plugin-azure-devops-common';

const isAzureDevOpsAvailable = (entity) => Boolean(entity.metadata.annotations?.[AZURE_DEVOPS_REPO_ANNOTATION]);
const isAzurePipelinesAvailable = (entity) => Boolean(entity.metadata.annotations?.[AZURE_DEVOPS_REPO_ANNOTATION]) || Boolean(entity.metadata.annotations?.[AZURE_DEVOPS_PROJECT_ANNOTATION]) && Boolean(
  entity.metadata.annotations?.[AZURE_DEVOPS_BUILD_DEFINITION_ANNOTATION]
);
const azureDevOpsPlugin = createPlugin({
  id: "azureDevOps",
  apis: [
    createApiFactory({
      api: azureDevOpsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef
      },
      factory: ({ discoveryApi, fetchApi }) => new AzureDevOpsClient({ discoveryApi, fetchApi })
    })
  ]
});
const AzurePullRequestsPage = azureDevOpsPlugin.provide(
  createRoutableExtension({
    name: "AzurePullRequestsPage",
    component: () => import('./components/PullRequestsPage/index.esm.js').then((m) => m.PullRequestsPage),
    mountPoint: azurePullRequestDashboardRouteRef
  })
);
const EntityAzurePipelinesContent = azureDevOpsPlugin.provide(
  createRoutableExtension({
    name: "EntityAzurePipelinesContent",
    component: () => import('./components/EntityPageAzurePipelines/index.esm.js').then(
      (m) => m.EntityPageAzurePipelines
    ),
    mountPoint: azurePipelinesEntityContentRouteRef
  })
);
const EntityAzureGitTagsContent = azureDevOpsPlugin.provide(
  createRoutableExtension({
    name: "EntityAzureGitTagsContent",
    component: () => import('./components/EntityPageAzureGitTags/index.esm.js').then(
      (m) => m.EntityPageAzureGitTags
    ),
    mountPoint: azureGitTagsEntityContentRouteRef
  })
);
const EntityAzurePullRequestsContent = azureDevOpsPlugin.provide(
  createRoutableExtension({
    name: "EntityAzurePullRequestsContent",
    component: () => import('./components/EntityPageAzurePullRequests/index.esm.js').then(
      (m) => m.EntityPageAzurePullRequests
    ),
    mountPoint: azurePullRequestsEntityContentRouteRef
  })
);
const EntityAzureReadmeCard = azureDevOpsPlugin.provide(
  createComponentExtension({
    name: "EntityAzureReadmeCard",
    component: {
      lazy: () => import('./components/ReadmeCard/index.esm.js').then((m) => m.ReadmeCard)
    }
  })
);

export { AzurePullRequestsPage, EntityAzureGitTagsContent, EntityAzurePipelinesContent, EntityAzurePullRequestsContent, EntityAzureReadmeCard, azureDevOpsPlugin, isAzureDevOpsAvailable, isAzurePipelinesAvailable };
//# sourceMappingURL=plugin.esm.js.map
